/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetNextActionSuggestions200Response } from '../models';
// @ts-ignore
import { PostNextActionSuggestionApproveRequest } from '../models';
/**
 * NextActionSuggestionApi - axios parameter creator
 * @export
 */
export const NextActionSuggestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 次のアクション候補一覧取得API
         * @summary 次のアクション候補一覧取得API
         * @param {number} [ownerId] 担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestions: async (ownerId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/next_action_suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ownerId !== undefined) {
                localVarQueryParameter['owner_id'] = ownerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 次のアクション候補承認API
         * @summary 次のアクション候補承認API
         * @param {number} nextActionSuggestionId 次のアクション候補ID
         * @param {PostNextActionSuggestionApproveRequest} postNextActionSuggestionApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNextActionSuggestionApprove: async (nextActionSuggestionId: number, postNextActionSuggestionApproveRequest: PostNextActionSuggestionApproveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nextActionSuggestionId' is not null or undefined
            assertParamExists('postNextActionSuggestionApprove', 'nextActionSuggestionId', nextActionSuggestionId)
            // verify required parameter 'postNextActionSuggestionApproveRequest' is not null or undefined
            assertParamExists('postNextActionSuggestionApprove', 'postNextActionSuggestionApproveRequest', postNextActionSuggestionApproveRequest)
            const localVarPath = `/api/user/next_action_suggestions/{nextActionSuggestionId}/approve`
                .replace(`{${"nextActionSuggestionId"}}`, encodeURIComponent(String(nextActionSuggestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postNextActionSuggestionApproveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 次のアクション候補拒否API
         * @summary 次のアクション候補拒否API
         * @param {number} nextActionSuggestionId 次のアクション候補ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNextActionSuggestionReject: async (nextActionSuggestionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nextActionSuggestionId' is not null or undefined
            assertParamExists('postNextActionSuggestionReject', 'nextActionSuggestionId', nextActionSuggestionId)
            const localVarPath = `/api/user/next_action_suggestions/{nextActionSuggestionId}/reject`
                .replace(`{${"nextActionSuggestionId"}}`, encodeURIComponent(String(nextActionSuggestionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NextActionSuggestionApi - functional programming interface
 * @export
 */
export const NextActionSuggestionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NextActionSuggestionApiAxiosParamCreator(configuration)
    return {
        /**
         * 次のアクション候補一覧取得API
         * @summary 次のアクション候補一覧取得API
         * @param {number} [ownerId] 担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextActionSuggestions(ownerId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextActionSuggestions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextActionSuggestions(ownerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 次のアクション候補承認API
         * @summary 次のアクション候補承認API
         * @param {number} nextActionSuggestionId 次のアクション候補ID
         * @param {PostNextActionSuggestionApproveRequest} postNextActionSuggestionApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNextActionSuggestionApprove(nextActionSuggestionId: number, postNextActionSuggestionApproveRequest: PostNextActionSuggestionApproveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNextActionSuggestionApprove(nextActionSuggestionId, postNextActionSuggestionApproveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 次のアクション候補拒否API
         * @summary 次のアクション候補拒否API
         * @param {number} nextActionSuggestionId 次のアクション候補ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNextActionSuggestionReject(nextActionSuggestionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNextActionSuggestionReject(nextActionSuggestionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NextActionSuggestionApi - factory interface
 * @export
 */
export const NextActionSuggestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NextActionSuggestionApiFp(configuration)
    return {
        /**
         * 次のアクション候補一覧取得API
         * @summary 次のアクション候補一覧取得API
         * @param {number} [ownerId] 担当者ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestions(ownerId?: number, options?: any): AxiosPromise<GetNextActionSuggestions200Response> {
            return localVarFp.getNextActionSuggestions(ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 次のアクション候補承認API
         * @summary 次のアクション候補承認API
         * @param {number} nextActionSuggestionId 次のアクション候補ID
         * @param {PostNextActionSuggestionApproveRequest} postNextActionSuggestionApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNextActionSuggestionApprove(nextActionSuggestionId: number, postNextActionSuggestionApproveRequest: PostNextActionSuggestionApproveRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postNextActionSuggestionApprove(nextActionSuggestionId, postNextActionSuggestionApproveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 次のアクション候補拒否API
         * @summary 次のアクション候補拒否API
         * @param {number} nextActionSuggestionId 次のアクション候補ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNextActionSuggestionReject(nextActionSuggestionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postNextActionSuggestionReject(nextActionSuggestionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NextActionSuggestionApi - interface
 * @export
 * @interface NextActionSuggestionApi
 */
export interface NextActionSuggestionApiInterface {
    /**
     * 次のアクション候補一覧取得API
     * @summary 次のアクション候補一覧取得API
     * @param {number} [ownerId] 担当者ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionApiInterface
     */
    getNextActionSuggestions(ownerId?: number, options?: AxiosRequestConfig): AxiosPromise<GetNextActionSuggestions200Response>;

    /**
     * 次のアクション候補承認API
     * @summary 次のアクション候補承認API
     * @param {number} nextActionSuggestionId 次のアクション候補ID
     * @param {PostNextActionSuggestionApproveRequest} postNextActionSuggestionApproveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionApiInterface
     */
    postNextActionSuggestionApprove(nextActionSuggestionId: number, postNextActionSuggestionApproveRequest: PostNextActionSuggestionApproveRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 次のアクション候補拒否API
     * @summary 次のアクション候補拒否API
     * @param {number} nextActionSuggestionId 次のアクション候補ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionApiInterface
     */
    postNextActionSuggestionReject(nextActionSuggestionId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getNextActionSuggestions operation in NextActionSuggestionApi.
 * @export
 * @interface NextActionSuggestionApiGetNextActionSuggestionsRequest
 */
export interface NextActionSuggestionApiGetNextActionSuggestionsRequest {
    /**
     * 担当者ID
     * @type {number}
     * @memberof NextActionSuggestionApiGetNextActionSuggestions
     */
    readonly ownerId?: number
}

/**
 * Request parameters for postNextActionSuggestionApprove operation in NextActionSuggestionApi.
 * @export
 * @interface NextActionSuggestionApiPostNextActionSuggestionApproveRequest
 */
export interface NextActionSuggestionApiPostNextActionSuggestionApproveRequest {
    /**
     * 次のアクション候補ID
     * @type {number}
     * @memberof NextActionSuggestionApiPostNextActionSuggestionApprove
     */
    readonly nextActionSuggestionId: number

    /**
     * 
     * @type {PostNextActionSuggestionApproveRequest}
     * @memberof NextActionSuggestionApiPostNextActionSuggestionApprove
     */
    readonly postNextActionSuggestionApproveRequest: PostNextActionSuggestionApproveRequest
}

/**
 * Request parameters for postNextActionSuggestionReject operation in NextActionSuggestionApi.
 * @export
 * @interface NextActionSuggestionApiPostNextActionSuggestionRejectRequest
 */
export interface NextActionSuggestionApiPostNextActionSuggestionRejectRequest {
    /**
     * 次のアクション候補ID
     * @type {number}
     * @memberof NextActionSuggestionApiPostNextActionSuggestionReject
     */
    readonly nextActionSuggestionId: number
}

/**
 * NextActionSuggestionApi - object-oriented interface
 * @export
 * @class NextActionSuggestionApi
 * @extends {BaseAPI}
 */
export class NextActionSuggestionApi extends BaseAPI implements NextActionSuggestionApiInterface {
    /**
     * 次のアクション候補一覧取得API
     * @summary 次のアクション候補一覧取得API
     * @param {NextActionSuggestionApiGetNextActionSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionApi
     */
    public getNextActionSuggestions(requestParameters: NextActionSuggestionApiGetNextActionSuggestionsRequest = {}, options?: AxiosRequestConfig) {
        return NextActionSuggestionApiFp(this.configuration).getNextActionSuggestions(requestParameters.ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 次のアクション候補承認API
     * @summary 次のアクション候補承認API
     * @param {NextActionSuggestionApiPostNextActionSuggestionApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionApi
     */
    public postNextActionSuggestionApprove(requestParameters: NextActionSuggestionApiPostNextActionSuggestionApproveRequest, options?: AxiosRequestConfig) {
        return NextActionSuggestionApiFp(this.configuration).postNextActionSuggestionApprove(requestParameters.nextActionSuggestionId, requestParameters.postNextActionSuggestionApproveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 次のアクション候補拒否API
     * @summary 次のアクション候補拒否API
     * @param {NextActionSuggestionApiPostNextActionSuggestionRejectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionApi
     */
    public postNextActionSuggestionReject(requestParameters: NextActionSuggestionApiPostNextActionSuggestionRejectRequest, options?: AxiosRequestConfig) {
        return NextActionSuggestionApiFp(this.configuration).postNextActionSuggestionReject(requestParameters.nextActionSuggestionId, options).then((request) => request(this.axios, this.basePath));
    }
}
